import type { KOutcome, TMOutcome } from '../engine/types'

interface ControlsProps {
  playing: boolean
  onPlay: () => void
  onPause: () => void
  onStep: () => void
  onBack: () => void
  onReset: () => void
  speed: number
  onSpeedChange: (speed: number) => void
  stepCount: number
  canBack: boolean
  countLabel: string
  outcome: KOutcome | TMOutcome
}

export function Controls({
  playing,
  onPlay,
  onPause,
  onStep,
  onBack,
  onReset,
  speed,
  onSpeedChange,
  stepCount,
  canBack,
  countLabel,
  outcome,
}: ControlsProps) {
  const terminal = outcome !== 'running'
  const speedLabel = Number.isInteger(speed) ? `${speed.toFixed(0)}×` : `${speed.toFixed(2)}×`

  return (
    <div className="km-controls">
      <div className="km-control-buttons">
        <button
          type="button"
          onClick={playing ? onPause : onPlay}
          disabled={terminal}
          className="km-button km-button-primary"
        >
          {playing ? 'Pause' : 'Play'}
        </button>
        <button type="button" onClick={onStep} disabled={terminal} className="km-button">
          Step
        </button>
        <button type="button" onClick={onBack} disabled={!canBack} className="km-button">
          Back
        </button>
        <button type="button" onClick={onReset} className="km-button">
          Reset
        </button>
      </div>

      <div className="km-control-meta">
        <label className="km-speed-control">
          <span>Speed</span>
          <input
            aria-label={`${countLabel} playback speed`}
            type="range"
            min={0.25}
            max={4}
            step={0.25}
            value={speed}
            onChange={(event) => onSpeedChange(Number(event.target.value))}
          />
          <span>{speedLabel}</span>
        </label>
        <span className={`km-outcome km-outcome-${outcome}`}>
          {countLabel}: {stepCount} · {outcome === 'running' ? 'running' : outcome === 'result' ? 'result' : 'no result'}
        </span>
      </div>
    </div>
  )
}
